const CARBON_FOOTPRINT_URL = `${process.env.REACT_APP_CARBON_FOOTPRINT_URL}`

const MGTTApiUrls = {
  GET_ADMIN_CONFIG: `${CARBON_FOOTPRINT_URL}/cal-cfc/config/hdr/get`,
  UPDATE_ADMIN_CONFIG: `${CARBON_FOOTPRINT_URL}/cal-cfc/config/hdr/update`,
  DELETE_ADMIN_CONFIG: `${CARBON_FOOTPRINT_URL}/cal-cfc/config/hdr/delete`,
  DOWNLOAD_ADMIN_CONFIG: `${CARBON_FOOTPRINT_URL}/cal-cfc/config/hdr/download`,
  CREATE_ADMIN_CONFIG: `${CARBON_FOOTPRINT_URL}/cal-cfc/config/hdr/create`,

  GET_ALL_TT: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/tt/get`,
  GET_ALL_TT_FOR_TRANSPORTERS: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/tt/get/transporters`,
  GET_ALL_TT_FOR_DRIVERS: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/tt/get/drivers`,
  ARCHIVE_TT: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/psa/archive/update`,
  RETRY_TT: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/tt/siga/retry`,
  GET_TT_WITH_SIGA_STATUS: `${CARBON_FOOTPRINT_URL}/cal-cfc/mgtt/tt/siga/updated/get`
}

export default MGTTApiUrls
